import React, {useContext, useState} from 'react';
import './Admin.scss';
import Users from './Users';
import Selections from '../selections/Selections';
import {getCurrentUserRole} from '../../helpers/helpers';
import {I18nContext} from "../../contexts/i18nContext";

const Admin = () => {
  const { t } = useContext(I18nContext);

  return (
    <>
      {getCurrentUserRole() === 'ADMIN' && (
        <div className='Admin'>
          <Users />
        </div>
      )}
    </>
  );
};

export default Admin;
